/*
Muestra la barra de filtros de búsqueda de sucursal y vendedor
Autor: Benjamín León
Fecha: 2025-01-20
*/
import React, { useState } from 'react'

import InputField from './InputField'

export interface BranchUserFilterForm {
  branch_name: string
  user_name: string
}
const BranchUserFilter: React.FC<{
  formData: BranchUserFilterForm
  updFormData: (f: BranchUserFilterForm) => void
}> = ({ formData, updFormData }) => {
  const [showFilters, setShowFilters] = useState<boolean>(false)
  const label = showFilters ? 'Esconder filtros de búsqueda' : 'Ver filtros de búsqueda'

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target

    if (formData) {
      // Llamamos a updFormData que esta afuera
      updFormData({
        ...formData,
        [name]: value,
      })
    }
  }

  return (
    <>
      <div className="flex justify-center mb-2">
        <button className="text-blue-500 font-bold" onClick={() => setShowFilters(!showFilters)} aria-label="Ver">
          {label}
        </button>
      </div>

      {showFilters && (
        <div className="grid grid-cols-2  gap-x-2">
          <InputField
            label="Sucursal"
            name="branch_name"
            type="string"
            value={formData.branch_name}
            handleInputChange={handleInputChange}
          />

          <InputField
            label="Vendedor"
            name="user_name"
            type="string"
            value={formData.user_name}
            handleInputChange={handleInputChange}
          />
        </div>
      )}
    </>
  )
}

export default BranchUserFilter
